export enum TeamLifecyclePeriodType {
	Usage,
	Retention
}